export var FileReadOnlyReason;
(function (FileReadOnlyReason) {
    FileReadOnlyReason["FILE_READ_ONLY_REASON_BINARY"] = "BINARY";
    FileReadOnlyReason["FILE_READ_ONLY_REASON_TOO_LARGE"] = "TOO_LARGE";
    FileReadOnlyReason["FILE_READ_ONLY_REASON_SYMLINK"] = "SYMLINK";
    FileReadOnlyReason["FILE_READ_ONLY_REASON_SUBMODULE"] = "SUBMODULE";
    FileReadOnlyReason["FILE_READ_ONLY_REASON_LFS_POINTER"] = "LFS_POINTER";
})(FileReadOnlyReason || (FileReadOnlyReason = {}));
